import { render } from "./CompanyRegistration.vue?vue&type=template&id=daeb4962&scoped=true"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js"

import "./CompanyRegistration.vue?vue&type=style&index=0&id=daeb4962&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daeb4962"]])

export default __exports__